import ArrowBack from 'material-ui/svg-icons/navigation/arrow-back';
import autoBind from 'react-autobind';
import {connect} from 'react-redux';
import {DocumentDownloader} from '../../shared/components';
import {handleApiError} from '../../shared/services';
import {Map} from 'immutable';
import muiThemes from '../../../styles/teamologyTheme';
import RaisedButton from 'material-ui/RaisedButton';
import {browserHistory, withRouter} from 'react-router';
import {
  LessonDetailContent,
  LessonDetailHeader,
  LessonDetailSideBar,
} from './index';
import {
  loadLessonPlan,
  registerHoverState,
  resetDownloadUrl,
  setDownloadUrl,
  updateHoverState,
} from '../actions';
import {MainContent, Page, PageBody} from '../../layout/components';
import React, {Component, PropTypes} from 'react';

class CoreLessonDetailPage extends Component {
  constructor(props, context) {
    super(props, context);
    autoBind(this);
  }

  componentDidMount() {
    const {lessonId} = this.props.params;
    const {loadLessonPlan, registerHoverState, router} = this.props;

    if (lessonId) {
      loadLessonPlan(lessonId)
        .catch(error => handleApiError(error, router, 'An error occurred while attempting to show the Lesson detail.', 'Error'));
    }

    registerHoverState(this.getHoverStateMap().backLink);
  }

  handleDownloadDocument(materialId) {
    this.props.setDownloadUrl(materialId);
  }

  handleDocumentDownloaded() {
    this.props.resetDownloadUrl();
  }

  handleBackNavigation() {
    browserHistory.goBack();
  }

  getHoverStateMap() {
    return {
      backLink: 'back-link',
    };
  }

  handleHover(id, value) {
    const {updateHoverState} = this.props;
    updateHoverState(id, value);
  }

  render() {
    const {downloadUrl, hoverStates, lessonPlan, loading} = this.props;
    const characterName = lessonPlan.getIn(['character', 'name']);
    const backLinkId = this.getHoverStateMap().backLink;
    const iconStyle = {
      color: hoverStates.get(backLinkId) ? muiThemes.palette.primary2Color : muiThemes.palette.primary1Color,
    };

    const headerStyle = {
      height: 5,
      backgroundColor: characterName ? muiThemes.characterColors[characterName.toLowerCase()] : null,
    };

    const headerClassName = characterName ? null : 'all-character-header';

    return (
      <Page pageClassName="lesson-detail-page">
        <div className={headerClassName} style={headerStyle} />
        <PageBody>
          <MainContent loading={loading} hideRainbow>
            <div>
              <div className="lesson-detail-top-bar">
                <div className="lesson-detail-back-link"
                  onClick={this.handleBackNavigation}
                  onMouseOver={this.handleHover.bind(this, this.getHoverStateMap().backLink, true)}
                  onMouseOut={this.handleHover.bind(this, this.getHoverStateMap().backLink, false)}>
                  <ArrowBack style={iconStyle} />
                </div>
              </div>

              <div className="lesson-detail-container">
                <div className="lesson-detail-header">
                  <LessonDetailHeader
                    lessonType={lessonPlan.get('lessonType')}
                    grades={lessonPlan.get('grades')}
                    characterName={lessonPlan.getIn(['character', 'name'])}
                    title={lessonPlan.get('title')} />
                </div>

                <div className="lesson-detail-body">
                  <div className="lesson-detail-content">
                    <LessonDetailContent content={lessonPlan.get('content')} />
                  </div>

                  <div className="lesson-detail-sidebar">
                    <LessonDetailSideBar
                      estimatedTimeTaken={lessonPlan.get('estimatedTimeTaken')}
                      materials={lessonPlan.get('materials')}
                      supplies={lessonPlan.get('supplies')}
                      onDownloadMaterial={this.handleDownloadDocument} />
                  </div>
                </div>
              </div>
            </div>
          </MainContent>
        </PageBody>
        <DocumentDownloader downloadUrl={downloadUrl} onDocumentDownloaded={this.handleDocumentDownloaded} />
      </Page>
    );
  }
}

CoreLessonDetailPage.propTypes = {
  downloadUrl: PropTypes.string.isRequired,
  hoverStates: PropTypes.instanceOf(Map).isRequired,
  lessonPlan: PropTypes.instanceOf(Map).isRequired,
  loadLessonPlan: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  params: PropTypes.object.isRequired,
  registerHoverState: PropTypes.func.isRequired,
  resetDownloadUrl: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
  setDownloadUrl: PropTypes.func.isRequired,
  updateHoverState: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  const {showLessonDetail} = state.features.lessonDetail.pages;
  return {
    downloadUrl: showLessonDetail.get('downloadUrl'),
    hoverStates: showLessonDetail.get('hoverStates'),
    lessonPlan: showLessonDetail.get('lessonPlan'),
    loading: showLessonDetail.get('loading'),
  };
}

export default withRouter(connect(
  mapStateToProps,
  {
    loadLessonPlan,
    registerHoverState,
    resetDownloadUrl,
    setDownloadUrl,
    updateHoverState,
  }
)(CoreLessonDetailPage));



// WEBPACK FOOTER //
// ./app/features/lessonDetail/components/CoreLessonDetailPage.js